import * as React from 'react';
import { BaseDropdownModalProps } from '../DropdownCommentsModal/DropdownCommentsModal';
import { ModelWithError } from '../../../../misc/api/apiTypes';
import { DropdownCommentTypes, ShouldDisplay } from '../DropdownCommentsModal/DropdownCommentsHelpers';
import { connect } from 'react-redux';
import { MainState } from '../../../../Core/reducers';
import { AuditModal } from '../../../../auditmodal/components/AuditModal';
import { useWebPortalLegacyClient } from '../../../../misc/api/WebPortalTokenClient';

interface StartNewReviewModalProps extends BaseDropdownModalProps, StartNewReviewModalOwnProps {

}

interface StartNewReviewModalOwnProps {
    onClose: () => void;
    analysisSetId: string;
    isAnalysisSetLinked: boolean;
    selectedDropdownCommentType: DropdownCommentTypes;
}

const StartNewReviewModal = ({ analysisSetId, selectedDropdownCommentType, onClose }: StartNewReviewModalProps): JSX.Element => {

    const [loading, setLoading] = React.useState<boolean>(false);
    const [err, setErr] = React.useState<string>();
    const legacyClient = useWebPortalLegacyClient();

    const resetOrStartReview = (auditAnnotation: string) => {
        return legacyClient.startNewReview(analysisSetId, auditAnnotation);
    }

    const message = "This will start a new review for this analysis set. Ensure that all current review comments are correct before proceeding as they cannot be updated later.";
    const header = "Start new analysis set review.";

    const shouldDisplay = ShouldDisplay(DropdownCommentTypes.StartNewReview);
    const getMessage = () => {
        return (<><em><strong>Warning: </strong></em> {message}</>);
    }

    return (shouldDisplay(analysisSetId, selectedDropdownCommentType) ? <AuditModal warning={getMessage()} isSubmitting={loading} error={err} header={header} onClose={onClose} onSubmit={(form) => {
        setErr(null);
        if (!form.Annotation || !form.Annotation.trim()) {
            setErr("An annotation is required.");
            return;
        }

        setLoading(true);
        resetOrStartReview(form.Annotation.trim())
            .then(() => onClose())
            .catch((err: ModelWithError) => {
                setErr(err.Errors[0].Message);
            })
            .finally(() => {
                setLoading(false);
            });
    }} /> : null);
};

function mapStateToProps(state: MainState, ownProps: StartNewReviewModalOwnProps): StartNewReviewModalProps {
    return {
        analysisSetId: ownProps.analysisSetId,
        isAnalysisSetLinked: ownProps.isAnalysisSetLinked,
        selectedDropdownCommentType: ownProps.selectedDropdownCommentType,
        onClose: ownProps.onClose
    };
}

export default connect<StartNewReviewModalProps, void, StartNewReviewModalOwnProps>(mapStateToProps)(StartNewReviewModal);
